import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { Controller, useForm } from 'react-hook-form';
import Accordion from '@mui/material/Accordion';
import Avatar from '@mui/material/Avatar';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Grid from '@mui/material/Grid';

import { Col, TitleFont } from '../../../libs/base/base-style';

import DatePicker from './DatePicker'
import Upload, { AvatarUpload } from './Upload'
import { FormTextField, FormRadioField, FormSelectField, FormCheckBoxField } from './FormInput'
import { useHorsesStore } from '../../../stores/horses'
import { observer, Observer } from 'mobx-react';
import { toJS } from 'mobx'
import SharePage from './ShareModal';
import { useHistory } from 'react-router-dom';
import Alert from './MsgModal'
import { Link } from 'react-router-dom';
import { Checkbox, FormControlLabel, Tooltip } from '@mui/material';

const NavigateButton: FunctionComponent<{ profileId?: string }> = (props) => {
    const targetUrl = "/eventCalendar";
    const params = {
        profileId: props.profileId ? props.profileId : '',
    };



    return (
        <Link to={{
            pathname: targetUrl,
            state: params
        }} >
            <SecBtn variant="outlined" startIcon={<StyledIcon />}>
                Calendar
            </SecBtn>
        </Link>
    );
};

const Profile: FunctionComponent<{ profileId?: string }> = (props) => {
    const [collapsed, setCollapsed] = useState(props.profileId ? false : true)
    const [alert, setAlert] = useState({ title: 'Info', msg: '', color: '', open: false })
    const stores = useHorsesStore()
    const route = useHistory()
    const [openModal, setOpenModal] = useState(false)
    const [avatar, setAvatar] = useState(stores.profile?.avatar)
    const methods = useForm(({ defaultValues: { nzcar: 'false', gender: 'colt', colour: 'Appaloosa', discipline: 'Stevie', 'avatar': '' } }));
    const { handleSubmit, control, setValue } = methods;

    // const usrId = useMemo(() => {
    //     return window.reactPress.user.data.ID
    // }, [])


    const onSubmit = async (data) => {
        const usrId = window.reactPress?.user.data.ID ? window.reactPress?.user.data.ID : '1'
        if (stores.profile?._ID != null) {
            try {
                await stores.updateProfile({ ...data, avatar: avatar })
                setAlert(prev => { return { ...prev, title: 'Great', msg: 'Your data has been successfully saved.', color: '#4BB543', open: true } })
            }
            catch {
                setAlert(prev => { return { ...prev, title: 'Opps', msg: 'Something went wrong. The profile was not updated.', color: '#FC100D', open: true } })
            }
        } else {//add profile
            const res = await stores.addProfile({ ...data, parent_order_id: stores.selectedOrderId, user_id: usrId, avatar: methods.getValues('avatar') })




            if (res.success == true) {
                const existingProfileIds = stores.horses.map(item => item._ID)
                if (existingProfileIds.length > 0) {
                    for (let index = 0; index < existingProfileIds.length; index++) {
                        const element = existingProfileIds[index];
                        const contacts = element && await stores.getContact(element)
                        if (contacts && contacts.length > 0) {

                            for (const contact of contacts) {
                                delete contact['cct_author_id']
                                delete contact['cct_created']
                                delete contact['cct_modified']
                                delete contact['cct_slug']
                                delete contact['cct_status']
                                delete contact['_ID']
                                contact.profile_id = String(res.item_id);

                                await stores.addContact(contact);
                            }
                            break;

                        }

                    }

                }

                route.push('/')
            }
        }
    }


    const updateAvatar = (url: string) => {
        if (stores.profile?._ID != null) {
            stores.updateAvatar({ avatar: url, id: stores.profile._ID })
        } else {
            methods.setValue('avatar', url)
            console.log(methods.getValues())
        }
    }

    const onClickShare = () => {

        setOpenModal(true)
    }

    useEffect(() => {
        if (props.profileId && stores.isEditingMode === true) {
            stores.getProfile(props.profileId)
        }

        return () => {
            stores.fulshProfile()
            console.log('flush ')
        }
    }, [props.profileId])

    useEffect(() => {
        const val = toJS(stores.profile)
        if (val) {
            methods.reset(val)
            val.nzcar && methods.setValue('nzcar', val.nzcar)
            console.log(val)
        }

    }, [stores.profile, stores.preview])

    return <Observer>{() =>
        <>
            <HeaderWrapper container>
                <Grid item>
                    <AvatarUpload img={toJS(stores.profile)?.avatar} onFinished={str => updateAvatar(str)} />
                </Grid>

            </HeaderWrapper>

            <NameWrapper container>
                <Grid justifyContent={'center'} alignItems={'center'} container spacing={2} sx={{
                    flexDirection: {
                        xs: 'column',
                        sm: "row"
                    }
                }}>
                    <Grid item >
                        <Typography fontSize={13} fontWeight={800} fontFamily={'inherit'}>Show name:</Typography>
                    </Grid>
                    <Grid item>
                        {stores.isEditingMode == true ?
                            <Title color='#408697'>{stores.profile?.show_name && collapsed == false ? stores.profile?.show_name :
                                <FormTextField required={true} placeholder='Placeholder' control={control} name='show_name' customLabel={<></>} label={''} disabled={stores.isEditingMode} />}
                            </Title>
                            :
                            <Title color='#408697'>{stores.preview?.profile?.show_name}
                            </Title>
                        }

                    </Grid>
                </Grid>
            </NameWrapper>
            <Col>
                <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} px={2}>
                    {stores.isEditingMode == true ? <>
                        {stores.profile?._ID &&
                            <>
                                <Btn variant="contained" startIcon={<IosShareOutlinedIcon />} onClick={onClickShare}>
                                    SHARE PROFILE
                                </Btn>
                                <SecBtn variant="outlined" startIcon={<StyledIcon />} onClick={() => setCollapsed(!collapsed)}>
                                    EDIT PROFILE
                                </SecBtn>
                                <NavigateButton profileId={props.profileId} />
                            </>}
                    </>
                        : <SecBtn variant="outlined" startIcon={<StyledIcon />} onClick={() => setCollapsed(!collapsed)}>
                            VIEW PROFILE
                        </SecBtn>
                    }
                </Stack>
                <StyledAccording expanded={collapsed} defaultExpanded={false} square disableGutters={true}>
                    <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >

                    </AccordionSummary>
                    <AccordionDetails>
                        <ProfileWrapper xs={12} md={5}>
                            <FormControl>
                                <Grid container spacing={2} alignItems="flex-start"
                                    justifyContent="flex-start">
                                    <InputGrid>
                                        <FormTextField required={true} control={control} name='paddock_name' label='Paddock Name:' disabled={stores.isEditingMode} />
                                    </InputGrid>
                                    <InputGrid>
                                        <StyleFormLabel>Year of Birth: </StyleFormLabel>
                                        <DatePicker control={control} name={'yob'} canEdit={stores.isEditingMode} limitMax={new Date()} onlyYear={true} />
                                    </InputGrid>
                                    <InputGrid>
                                        <FormTextField control={control} name='weight' label='Weight:' disabled={stores.isEditingMode} />
                                    </InputGrid>
                                    <InputGrid>
                                        <FormTextField control={control} name='height' label='Height:' disabled={stores.isEditingMode} />
                                    </InputGrid>
                                    <InputGrid>
                                        <FormRadioField control={control} label='Gender' name='gender' disabled={stores.isEditingMode} options={
                                            [{
                                                value: 'colt',
                                                label: 'Colt'
                                            }, {
                                                value: 'mare',
                                                label: 'Mare'
                                            }, {
                                                value: 'gelding',
                                                label: 'Gelding'
                                            }, {
                                                value: 'stallion',
                                                label: 'Stallion'
                                            }]
                                        } />
                                    </InputGrid>
                                    <InputGrid>
                                        <FormTextField control={control} name='register_number' label='Registration Number:' disabled={stores.isEditingMode} />
                                    </InputGrid>
                                    <InputGrid>
                                        <FormTextField control={control} name='microchip_no' label='Microchip No.:' disabled={stores.isEditingMode} />
                                        <FormCheckBoxField control={control} name='nzcar' disabled={stores.isEditingMode} label={'NZCAR'} />
                                    </InputGrid>
                                    <InputGrid>
                                        <FormSelectField control={control} label='Breed:' name='breed' helpText='Please select breed' disabled={stores.isEditingMode}
                                            options={[{
                                                value: 'Andalusian',
                                                label: 'Andalusian'
                                            }, {
                                                value: 'Appaloosa',
                                                label: 'Appaloosa'
                                            }, {
                                                value: 'Arab',
                                                label: 'Arab'
                                            }, {
                                                value: 'Clydesdale',
                                                label: 'Clydesdale'
                                            }, {
                                                value: 'Connemara',
                                                label: 'Connemara'
                                            }, {
                                                value: 'Crossbreed',
                                                label: 'Crossbreed'
                                            }, {
                                                value: 'Gypsey Cob',
                                                label: 'Gypsey Cob'
                                            }, {
                                                value: 'Haflinger',
                                                label: 'Haflinger'
                                            }, {
                                                value: 'Irish',
                                                label: 'Irish'
                                            }, {
                                                value: 'Kaimanawa',
                                                label: 'Kaimanawa'
                                            }, {
                                                value: 'Lusitano',
                                                label: 'Lusitano'
                                            }, {
                                                value: 'Morgan',
                                                label: 'Morgan'
                                            }, {
                                                value: 'NZ Sport Horse',
                                                label: 'NZ Sport Horse'
                                            }, {
                                                value: 'Quarter Horse',
                                                label: 'Quarter Horse'
                                            }, {
                                                value: 'Riding Pony',
                                                label: 'Riding Pony'
                                            }, {
                                                value: 'Standardbred',
                                                label: 'Standardbred'
                                            }, {
                                                value: 'Thoroughbred',
                                                label: 'Thoroughbred'
                                            }, {
                                                value: 'Trakehner',
                                                label: 'Trakehner'
                                            }, {
                                                value: 'Warmblood',
                                                label: 'Warmblood'
                                            }, {
                                                value: 'Welsh',
                                                label: 'Welsh'
                                            }, {
                                                value: 'Other',
                                                label: 'Other'
                                            }
                                            ]} />
                                    </InputGrid>
                                    <InputGrid>
                                        <FormSelectField control={control} label='Colour:' name='colour' helpText='Please select colour' disabled={stores.isEditingMode}
                                            options={[{
                                                value: 'Appaloosa',
                                                label: 'Appaloosa'
                                            }, {
                                                value: 'Bay',
                                                label: 'Bay'
                                            }, {
                                                value: 'Buckskin',
                                                label: 'Buckskin'
                                            }, {
                                                value: 'Chestnut',
                                                label: 'Chestnut'
                                            }, {
                                                value: 'Coloured',
                                                label: 'Coloured'
                                            }, {
                                                value: 'Dark Brown',
                                                label: 'Dark Brown'
                                            }, {
                                                value: 'Grey',
                                                label: 'Grey'
                                            }, {
                                                value: 'Liver Chestnut',
                                                label: 'Liver Chestnut'
                                            }, {
                                                value: 'Palamino',
                                                label: 'Palamino'
                                            }, {
                                                value: 'Roan',
                                                label: 'Roan'
                                            }, {
                                                value: 'Other',
                                                label: 'Other'
                                            }
                                            ]} />
                                    </InputGrid>
                                    <InputGrid>
                                        <FormSelectField control={control} label='Discipline:' name='discipline' helpText='Please select discipline' disabled={stores.isEditingMode}
                                            options={[{
                                                value: 'Beyond the Barriers / Off the Track',
                                                label: 'Beyond the Barriers / Off the Track'
                                            }, {
                                                value: 'Breeding Stock',
                                                label: 'Breeding Stock'
                                            }, {
                                                value: 'Dressage',
                                                label: 'Dressage'
                                            }, {
                                                value: 'Endurance',
                                                label: 'Endurance'
                                            }, {
                                                value: 'Eventers',
                                                label: 'Eventers'
                                            }, {
                                                value: 'Farm Hack',
                                                label: 'Farm Hack'
                                            }, {
                                                value: 'First Ridden',
                                                label: 'First Ridden'
                                            }, {
                                                value: 'Games',
                                                label: 'Games'
                                            }, {
                                                value: 'Hunting',
                                                label: 'Hunting'
                                            }, {
                                                value: 'Miniature Horses',
                                                label: 'Miniature Horses'
                                            }, {
                                                value: 'Pleasure',
                                                label: 'Pleasure'
                                            }, {
                                                value: 'Polo',
                                                label: 'Polo'
                                            }, {
                                                value: 'Pony Club',
                                                label: 'Pony Club'
                                            }, {
                                                value: 'Race Horses',
                                                label: 'Race Horses'
                                            }, {
                                                value: 'Show Hunter',
                                                label: 'Show Hunter'
                                            }, {
                                                value: 'Show Jumpers',
                                                label: 'Show Jumpers'
                                            }, {
                                                value: 'Showing',
                                                label: 'Showing'
                                            }, {
                                                value: 'Stallion',
                                                label: 'Stallion'
                                            }, {
                                                value: 'Western',
                                                label: 'Western'
                                            }, {
                                                value: 'Young Stock',
                                                label: 'Young Stock'
                                            }, {
                                                value: 'Other',
                                                label: 'Other'
                                            }
                                            ]} />
                                    </InputGrid>
                                    <InputGrid>
                                        <FormTextField control={control} name='sire' label='Sire:' disabled={stores.isEditingMode} />
                                    </InputGrid>
                                    <InputGrid>
                                        <FormTextField control={control} name='dam' label='Dam:' disabled={stores.isEditingMode} />
                                    </InputGrid>
                                    <InputGrid>
                                        <FormTextField control={control} name='dam_sire' label='Dam Sire:' disabled={stores.isEditingMode} />
                                    </InputGrid>
                                    <InputGrid >
                                        <FormTextField control={control} name='gear_used' label='Gear used:' disabled={stores.isEditingMode} />
                                    </InputGrid>
                                    <InputGrid >
                                        <FormTextField control={control} name='insurance_num' label='Insurance Policy Number:' disabled={stores.isEditingMode}
                                            desc={<div style={{ fontSize: '0.9rem' }}>Do you want to get an insurance quote for your horse? Visit <a href='https://www.petcovergroup.com/nz/horse-insurance/'>https://www.petcovergroup.com/nz/horse-insurance/</a></div>}
                                        />
                                    </InputGrid>
                                    {/* <InputGrid>
                                        <StyleFormLabel>Date Purchased: </StyleFormLabel>
                                        <DatePicker control={control} name={'date_purchased'} canEdit={stores.isEditingMode} limitMax={new Date()} />
                                    </InputGrid> */}
                                    {stores.isEditingMode == true ? stores.profile?._ID != null && <InputGrid>
                                        <StyleFormLabel>Upload Files: </StyleFormLabel>
                                        <Upload />
                                    </InputGrid> : stores.preview?.profile._ID != null && <InputGrid>
                                        <StyleFormLabel>Upload Files: </StyleFormLabel>
                                        <Upload />
                                    </InputGrid>}



                                    <StyledGrid item xs={12}>
                                        <FormTextField control={control} name='notes' label='Notes:' multiline={true} disabled={stores.isEditingMode} />

                                    </StyledGrid>
                                    {stores.isEditingMode == true && <StyledGrid item xs={12}>
                                        <Button sx={{
                                            backgroundColor: '#408697 !imporatant',
                                            width: {
                                                xs: '100%',
                                                sm: 'inherit',

                                            }
                                        }} onClick={handleSubmit(onSubmit, (err) => console.log(err))} variant={"contained"}>
                                            Save
                                        </Button>
                                    </StyledGrid>}
                                </Grid>
                            </FormControl>
                        </ProfileWrapper>
                    </AccordionDetails>
                </StyledAccording>
            </Col>
            <SharePage open={openModal} close={() => setOpenModal(false)} profileId={stores.profile?._ID} shareKey={''} />
            <Alert {...alert} close={() => setAlert(prev => { return { ...prev, open: false } })} />
        </>
    }
    </Observer>
}

const StyledAvatar = styled(Avatar)`
    margin:10px;
`
const Title = styled(TitleFont)`
    font-size: 35px;
    margin: 20px;
    font-weight: 800;
    font-family: inherit;
`
const HeaderWrapper = styled(Grid)`
    display:flex;
    justify-content: center;
    align-items:center;
    margin-top:10px;
`
const StyledFont = styled(TitleFont)`
    border-bottom:solid 3px #408697;
    height:40px;
`
const StyledIcon = styled(EditOutlinedIcon)`
    color:#408697;
`

const StyledBtn = styled(Button)`
    background-color: transparent !important;
    color: white !important;
    font-weight: 900 !important;
    font-size: 14px !important;
    text-transform: none !important;
`
const FilledBtn = styled(StyledBtn)`
    background-color: #408697 !important;
    font-weight: 900 !important;
    font-family: inherit;
    height:40px !important;
    width:250px !important;
    font-size: 12px !important;
    border-radius:0 !important;
`

const OutlinedBtn = styled(FilledBtn)`
    background-color: transparent !important;
    color: black !important;
    border-color:#3333  !important;
`

const Styledbar = styled(AppBar)`
    background-color:#408697 !important;
    box-shadow: none !important;
    
`
const NameWrapper = styled(HeaderWrapper)`
    flex-direction:column;
    margin-top:15px;
    margin-bottom: 15px;
`

const StyledAccording = styled(Accordion)`
    background-color: transparent !important;
    box-shadow: none !important;
    border: 0 !important;
    position: initial !important;
`
const StyledUploadBtn = styled(Button)`
    background-color: #ededed !important;
`
const StyledGrid = styled(Grid)`
    text-align:center;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`
const ProfileWrapper = styled(Grid)`
    display:flex;
    justify-content:center;
    margin: auto;
`
const StyleFormLabel = styled(FormLabel)({
    'font-size': '14px',
    'font-weight': ' 800 !important',
    'width': '80px',
    '&.Mui-focused': {
        color: '#00000099 !important'
    }
})

const Btn = styled(FilledBtn)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        fontSize: '1rem !important',

    },
}));
const SecBtn = styled(OutlinedBtn)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        fontSize: '1rem !important',

    },
}));

const InputGrid: FunctionComponent<React.PropsWithChildren> = (props) => {
    return <StyledGrid item xs={12} md={6} {...props}>{props.children}</StyledGrid>
}

export default observer(Profile)